// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__FrVRA","item":"style_item__2srcO","number":"style_number__3S1kl","label":"style_label__1FzJj","img":"style_img__1wx7e","allbtn":"style_allbtn__35lEL"};